import React from 'react';
import styles from './style.module.css';
import { RobotAssistantIcon } from '../../assets/images/icons/RobotAssistant';

export enum AssistantMessageVariant {
  success = 'success',
  warning = 'warning',
  danger = 'danger',
  default = 'default',
}

export enum AssistantMessageSize {
  small = 'small',
  large = 'large',
}

export type AssistantMessageProps = {
  variant?: keyof typeof AssistantMessageVariant;
  className?: string;
  children?: React.ReactNode;
  size?: keyof typeof AssistantMessageSize;
  iconSize?: 'default' | 'small';
};

export function AssistantMessage({
  variant = 'default',
  size = 'large',
  iconSize = 'default',
  children,
  className,
}: AssistantMessageProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={[styles.container, className].filter(Boolean).join(' ')}
    >
      <RobotAssistantIcon
        xlinkTitle="Assistente"
        className={[styles.image, styles[`icon-${iconSize}`]].join(' ')}
      />
      <div
        className={[
          styles.content,
          styles[`variant-${variant}`],
          styles[`size-${size}`],
        ].join(' ')}
      >
        {children}
      </div>
    </div>
  );
}
